import { SvgIcon } from '@material-ui/core';
import React from 'react';

const DownloadIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5970_259)">
        <path d="M10.9487 11.7947V2.73157" stroke="#EEF2E4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.0698 11.7947V16.9737H3.82764V11.7947" stroke="#EEF2E4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.1856 8.55789L10.9488 11.7947L7.71191 8.55789" stroke="#EEF2E4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5970_259">
          <rect width="20.7158" height="20.7158" fill="white" transform="translate(0.59082 0.14209)" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default DownloadIcon;
